export const accountInfoLabels = [`first_name`, `last_name`, `email`];
export const addressInfoLabels = [`city`, `country`, `postal_code`, `region`, `street1`];
export const addressInfoOptionalLabels = [`phone`, `street2`];
export const planPurchaseLabels = [`payment_currency`, `payment_method`, `plan_code`];
